import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

const settingMenus = (): CloudPremisePluginMenu[] => {
    return [
        {
            name: "Setup Hestia",
            key: "hestia",
            route: "/hestia/setup",
            privacy: "private",
        },
    ];
};

export default settingMenus;